export function isSearchDisabled(raw: string | null | undefined): boolean {
  if (raw === null || raw === undefined || raw === '') {
    return false;
  }
  const trimmed = raw.trim();
  if (!trimmed) {
    return true;
  }
  if (/^\d+$/.test(trimmed)) {
    return false;
  }
  const firstWord = trimmed.split(/\s+/)[0];
  return firstWord.length < 3;
}